interface Props {
  index: string;
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  subtitle,
  align = "left",
  light = false,
}: Props) {
  const centered = align === "center";
  return (
    <div className={centered ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <div
        className={`inline-flex items-center gap-2 ${
          centered ? "justify-center" : ""
        } ${light ? "text-accent-300" : "text-primary-600"}`}
      >
        <span className="font-heading text-sm font-bold tracking-widest">{index}</span>
        <span className="h-px w-6 bg-current" />
        <span className="text-xs font-medium tracking-widest uppercase">{eyebrow}</span>
      </div>
      <h2
        className={`mt-3 font-heading text-3xl font-bold tracking-tight md:text-4xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            light ? "text-background-200/85" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}